import styled from 'styled-components';
import { Button } from 'v3/components';

export const AccordionDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 16px;
`;

export const DrawerContainer = styled.div`
  min-width: 500px;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100dvh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #d9d9d9;
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
`;

export const DrawerContent = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const DrawerGroupHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
  background: #fff;
`;

export const ButtonDrawer = styled(Button)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 16px;
  }
`;
